<template>
    <dashboard-layout tit="근로 계약서 관리" fullHeight topBtn>
        <template slot="topBtn">
            <v-btn color="secondary" href="https://service.papaya.camp/3feji24psdi3fl/app/dnic_worker_app.apk" download> 안드로이드 앱 다운로드 </v-btn>
        </template>
        <template slot="contents">

            <div class="mb-20 mb-lg-40" style="flex: 0 0 auto;">
                <v-badge floating dot >
                    <h4 class="tit--sm line-height-1">계약서 목록</h4>
                </v-badge>
            </div>

            <template v-if="contracts.length">
                <div class="v-cards">
                    
                    <!-- 계약서 -->
                    <employment-item v-for="contract in contracts" :key="contract._id" :value="contract" @show="show"/>

                </div>
            </template> 

            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요. <br />
                        계약서가 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 지원하기</span>
                    </v-btn>
                </v-layout>
            </template>

        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { USER_LIKE_TYPES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import EmploymentItem from "@/components/dashboard/person/employment/employment-item.vue";

export default {
    components: {
        DashboardLayout,
        EmploymentItem,
    },
    data(){
        return{
            summary: { totalcount: 0 },
            contracts: [],
        }
    },
    mounted(){
        this.search();
    },
    methods:{
        async search(){
            try{
                const { summary, contracts } = await api.v1.person.employment.contracts.gets({});

                this.contracts = contracts;
                this.summary = summary;

            } catch(err){
                console.error(err);
            }
        },
        show(){
            this.search();
        }
    },
};
</script>

<style></style>
